@if (hasTooltipContent) {
  <button
    type="button"
    class="bw-info-tooltip"
    [class.is-compact]="compact"
    [attr.aria-label]="label"
    [ngbTooltip]="tooltipContent"
    [placement]="placement"
    [container]="'body'"
    [tooltipClass]="'bw-info-tooltip__popup'"
    [openDelay]="openDelay"
    triggers="mouseenter:mouseleave click:blur focus:blur"
  >
    <fa-icon [icon]="icon"></fa-icon>
  </button>

  <ng-template #tooltipContent>
    <div class="bw-info-tooltip__content">
      @if (title.trim()) {
        <div class="bw-info-tooltip__title">{{ title }}</div>
      }
      @if (text.trim()) {
        <div class="bw-info-tooltip__text">{{ text }}</div>
      }
      @if (lines.length) {
        <ul class="bw-info-tooltip__list">
          @for (line of lines; track line) {
            <li>{{ line }}</li>
          }
        </ul>
      }
    </div>
  </ng-template>
}
